/* /me (core Frappe's own "My Account" page, frappe/public/scss/website/
 * my_account.scss) sits outside any [data-rfhq-theme] scope, same root
 * cause already diagnosed and fixed for the filter sidebar, /shop-by-
 * category, PDP, and Cart: RFHQ's --rfhq-* custom properties only exist
 * inside a themed ancestor, never globally. .account-info paints its own
 * background from --fg-color (a plain light-mode literal), and
 * .my-account-header/.my-account-name/.my-account-item/.my-account-item-desc
 * all read plain --gray-900/--gray-700 literals - none of it tracks the
 * site's real theme. Same fix: claim it data-rfhq-owned and hand it to the
 * existing site-theme fallback.
 */

frappe.ready(function () {
	var el = document.querySelector('.my-account-container');
	if (!el) return; // not this page

	el.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
});
